/**
 * FeatherIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const FeatherIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M20.264 3.739a5.94 5.94 0 0 0-8.398 0L6.176 9.42a4 4 0 0 0-1.172 2.819v5.373l-2.718 2.719a.977.977 0 1 0 1.382 1.382l2.726-2.728h5.354a4 4 0 0 0 2.817-1.164l5.69-5.682a5.93 5.93 0 0 0 0-8.401zm-1.39 7.028-5.69 5.682c-.382.382-.9.591-1.436.591h-3.4l8.353-8.355a.977.977 0 0 0-1.381-1.382l-8.362 8.365v-3.42c0-.535.218-1.054.59-1.436l5.69-5.682a3.987 3.987 0 0 1 5.635 0 3.99 3.99 0 0 1 0 5.637" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const FeatherIcon = makeIcon('FeatherIcon', FeatherIconSvg)
